import '../../resources/css/settings/AccountSettingsList.scss';
import 'react-tabulator/lib/styles.css';
import "react-tabulator/lib/css/bootstrap/tabulator_bootstrap4.min.css";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { listDateFormatter } from '../common/access-list';
import { ReactTabulator } from 'react-tabulator';
import DateFilter from './DateFilter';
import {
  doGetAccountDetail,
  doSelectAccount,
  doDeleteAccount,
  doConfirmAccountApply,
  DELETE_SETTING_ACCOUNT_SUCCESS,
  DELETE_SETTING_ACCOUNT_FAIL,
  SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS,
  CONFIRM_SETTING_ACCOUNT_APPLY_SUCCESS,
  loadAccountSettingList,
  SAVE_SETTING_ROLE_DETAIL_SUCCESS,
  saveAccountOperationStatus, saveAccountOperationStatusInFrontEnd
} from '../../actions/settings/index';
import { popupModalConfirm, openModal, openPickModal, MODAL_PICK_SAVE, openModalAlert } from '../../actions/index';
import ListColumnBtn from '../common/ListColumnBtn';

let orgFilter;


// const EnabledBtn = (props) => {
//   let iconContent;
//   if (props.cell._cell.value) {
//     iconContent = <span className='icon-btn-checkbox-p'></span>;
//   } else {
//     iconContent = <span className='icon-btn-checkbox-n'></span>;
//   }

//   return <div className='area-enabled-icon'>{ iconContent }</div>
// }



class AccountSettingsList extends Component {

  tableId = 'AccountSettingsList'
  // set this state for re-fresh sub component
  state = {
    refTable: null,
    isInitComplete: false, 
    sessionKey: window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT['manager'],
    pageSize: 10,
    pageSizeList: [10, 20, 30, 40],
    dateFilter: {
      from: null,
      to: null,
      column: null
    },
    visibleColumnsConfig : {
      columns: [
        { title: "ID", field: "seq" },
        { title: "Account", field: "account" },
        { title: "Name", field: "name" },
        { title: "Email", field: "email" },
        { title: "Role Name", field: "roleName" },
        { title: "Enabled", field: "enabled" },
        { title: "Fails Count", field: "failsCount" },
        { title: "Password Expire Date", field: "expirationDate" },
        { title: "Lock Login", field: "lockLogin" },
        { title: "Lock Login Date", field: "lockLoginDate" },
        { title: "Password Change Date", field: "pwdChange" },
        { title: "Last Login Date", field: "lastLoginDate" },
        { title: "Created Date", field: "createdDate" },
        { title: "Created By", field: "createName" },
        { title: "Last Updated Date", field: "lastUpdatedDate" },
        { title: "Last Updated By", field: "lastUpdatedName" },        
        { title: "buttonGroup", field: "buttonGroup", visible: false }
      ]
    },
  }  

  readyToAdd = (e) => {
    const { openPickModal } = this.props;
    openPickModal("settingsAccountReadyAdd", null);
  }

  addRow = () => {
    const { doSelectAccount, openModal } = this.props;
    openModal("settingsAccount", 'add', null, () => doSelectAccount(null));
  }

  dataLoading = (datas) => {
    if (this.ref && !this.state.isInitComplete) {

      // save into state
      this.setState({
        isInitComplete: true,
        refTable: this.ref.table
      });
    }
  }

  dateFormatterParams = {
    dateFormat: "YYYY-MM-DD HH:mm:ss",
    timezone: this.props.timeZoneID
  };

  columns = [
    { title: "ID", field: "seq", visible: false },
    { title: "Account", field: "account", visible: false },
    { title: "Name", field: "name" },
    { title: "Email", field: "email" },
    { title: "Role", field: "roleName" },
    { title: "Enabled", field: "enabled", width: 100, headerSort: false, /*formatter: reactFormatter(<EnabledBtn componentProps={this.props}/>)*/},
    { title: "Password Expire Date", field: "expirationDate", formatter: listDateFormatter, formatterParams: this.dateFormatterParams, visible: false },
    { title: "Lock Login", field: "lockLogin", width: 100, headerSort: false, /*formatter: reactFormatter(<EnabledBtn componentProps={this.props}/>)*/ },
    { title: "Lock Login Date", field: "lockLoginDate", formatter: listDateFormatter, formatterParams: this.dateFormatterParams, visible: false },
    { title: "Password Change Date", field: "pwdChange", formatter: listDateFormatter, formatterParams: this.dateFormatterParams, visible: false },
    { title: "Last Login Date", field: "lastLoginDate", formatter: listDateFormatter, formatterParams: this.dateFormatterParams },
    { title: "Created Date", field: "createdDate", formatter: listDateFormatter, formatterParams: this.dateFormatterParams, visible: false },
    { title: "Created By", field: "createName", visible: false},
    { title: "Last Updated Date", field: "lastUpdatedDate", formatter: listDateFormatter, formatterParams: this.dateFormatterParams},
    { title: "Last Updated By", field: "lastUpdatedName" },
  ];

  handleDateFilter = ({ from, to, column }) => {
    this.setState({ 
      dateFilter: { from, to, column }
    }, () => {
      if (this.state.refTable) {
        this.state.refTable.setFilter(this.filterByDate);
      }
    });
  }

  filterByDate = (data) => {
    const { dateFilter } = this.state;
    if (!dateFilter.from || !dateFilter.to || !dateFilter.column) return true;

    const dateValue = data[dateFilter.column];
    if (!dateValue) return false;

    const rowDate = new Date(dateValue);
    const fromDate = new Date(dateFilter.from);
    const toDate = new Date(dateFilter.to);
    toDate.setHours(23, 59, 59, 999); // Include the entire end day

    return rowDate >= fromDate && rowDate <= toDate;
  }

  renderTable = () => {
    const { tabulatorDivHeight, authToken, openModal, doGetAccountDetail, loadAccountSettingList, notifyItemData } = this.props;
    const {pageSize, pageSizeList} = this.state;

    const options = {
      height: tabulatorDivHeight,
      maxHeight: "calc(100vh - 250px)",
      ajaxURL: window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER["account"] + "/get-all",
      pagination: "local",
      paginationSize: pageSize ? pageSize : 10,
      paginationSizeSelector: pageSizeList,
      layout: "fitColumns",

      ajaxConfig: {
        method: 'POST',
        mode: 'cors'
      },
      ajaxContentType: {
        headers: {
          'Authorization': authToken,
          'Content-Type': 'application/json',
        },
        body: function (url, config, params) {
          //url - the url of the request
          //config - the fetch config object
          //params - the request parameters          
          return JSON.stringify({
            organizationId: orgFilter,
            account: notifyItemData? notifyItemData.account : null
          });
        },
      },

      ajaxResponse: (url, params, response) => {
        // loadDemoOnline(response.deviceUsage, response.data);
        loadAccountSettingList(response.data);
        if (this.state.dateFilter.from && this.state.dateFilter.to && this.state.dateFilter.column) {
          setTimeout(() => {
            this.state.refTable.setFilter(this.filterByDate);
          }, 0);
        }
        return response.data;
      },
      ajaxError: (error) => {
        console.info(this.tableId + ' ajaxError');
      }
    };

    return (
      <ReactTabulator
        ref={(ref) => (this.ref = ref)}
        columns={this.columns}
        data={[]}
        placeholder="No data found"
        options={options}
        className="custom-list-table"  //custom-list-table
        dataLoading={this.dataLoading}
        pageLoaded={this.pageLoaded}
        rowClick={function(e, row) {
          openModal("settingsAccount", 'view', null, () => doGetAccountDetail(authToken, row._row.data.seq));
        }}
      />
    );
  }

  pageLoaded = () => {
    const { refTable } = this.state;
    const { authToken ,accountOperationStatusList, saveAccountOperationStatus, saveAccountOperationStatusInFrontEnd } = this.props;
    console.log( accountOperationStatusList);

    accountOperationStatusList[this.tableId]["pageSize"] = accountOperationStatusList[this.tableId]["pageSize"] ? refTable.modules.page.size : 10;
    saveAccountOperationStatusInFrontEnd(accountOperationStatusList);
    saveAccountOperationStatus(authToken ,this.tableId, accountOperationStatusList[this.tableId]);
    window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT_OPERATION_STATUS,JSON.stringify(accountOperationStatusList));
  }

  reloadList = (e) => {
    const { refTable } = this.state;
    if (refTable) {
      refTable.clearData();
      // refTable.modules.page.reset(true, true);
      refTable.replaceData();
      // refTable.modules.ajax.loadData(true, true);
    }
  }

  reloadData = (account) => {
    const { refTable } = this.state;

        refTable.options.ajaxContentType.body = (url, config, params) => {
          return JSON.stringify({
            organizationId: orgFilter,
            account: account
          })
        }
        this.reloadList();
  }
  
  componentDidMount(){
    const {selectSite} = this.props;
    orgFilter = selectSite;

    const session = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT_OPERATION_STATUS));
    const newPageSize = session[this.tableId] ? session[this.tableId]["pageSize"] : 10;

    this.setState({
      pageSize: newPageSize,
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { menuMode/*, tabulatorDivHeight*/, status, errMsg, modalPick, authToken, selectSite, doConfirmAccountApply, openModalAlert, loginStatus, notifyItemData } = this.props;
    const { refTable } = this.state;

    if (refTable) {
      if (prevProps.menuMode !== menuMode) {
        // if menu chagne size(mode), need redraw table     
        refTable.redraw(true);
      }

      // if (typeof tabulatorDivHeight === 'number') {
      //   refTable.setHeight(tabulatorDivHeight);
      // }

      if (prevProps.menuMode !== status) {
        if (DELETE_SETTING_ACCOUNT_SUCCESS === status) {
          this.reloadData(null);
        } else if (DELETE_SETTING_ACCOUNT_FAIL === status && errMsg) {
          openModalAlert(errMsg);
        } else if (SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS === status) {
          this.reloadData(null);
        } else if (CONFIRM_SETTING_ACCOUNT_APPLY_SUCCESS === status) {
          this.reloadData(null);
        } else if (SAVE_SETTING_ROLE_DETAIL_SUCCESS === status) {
          this.reloadData(null);
        }
      }
      if(prevProps.selectSite !== selectSite){
        orgFilter = selectSite;
        this.dateFormatterParams.timezone = this.props.timeZoneID;
        this.reloadData(null);
      }
      if(prevProps.loginStatus !== loginStatus && loginStatus === "DO_CHANGE_NAME_SUCCESS"){
        this.reloadData(null);
      }
      if(notifyItemData && prevProps.notifyItemData !== notifyItemData) {
        this.reloadData(notifyItemData.account);
      }
    }

    if (prevProps.modalPick.modalMessage !== modalPick.modalMessage && modalPick.modalStatus === 'settingsAccountReadyAdd') {
      if (modalPick.modalMessage === MODAL_PICK_SAVE) {
        if (modalPick.modalResult !== undefined && modalPick.modalResult !== null) {
          const objForm = {
            organization: selectSite,
            applyList: modalPick.modalResult
          };
          doConfirmAccountApply(authToken, objForm);
        }
      }
    }
  }

  render() {
    const { visibleColumnsConfig } = this.state;
    const { openModalAlert } = this.props;

    return (
      <div className='account-setting-list'>
        {/* <div className='area-line'/> */}
        <DateFilter onApply={this.handleDateFilter} componentName="AccountSettingsList" openModalAlert={openModalAlert}/>
        <div className='area-header-btns'>
          {/* <div className='area-ready-to-add-btn' onClick={ this.readyToAdd }>
            <div className='area-icon'><span className='btn-ready-add-icon' ></span></div>
            <div className='area-text'>Ready to add</div>
          </div> */}
          <div className='area-add-btn'  onClick={ this.addRow }>
            <div className='area-icon'><span id="account-setting-list-add" className='icon-btn-add-n'></span></div>
            <div className='area-text'>Add new account</div>
          </div>
        </div>        
        {/* <div className='area-line'/> */}
        <div className='area-custom-list'>
          <span className='area-setting-list-icon'>
            <ListColumnBtn id="account-setting-list-column"
                            tableId={this.tableId}
                            refTable={this.state.refTable} 
                            refs={(ref) => {this.refTableToolBar = ref;}}
                            visibleColumnsConfig={visibleColumnsConfig}>
            </ListColumnBtn>
          </span>
          { this.renderTable() }
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    authToken: state.loginReducers.authToken,
    timeZoneID: state.loginReducers.timeZoneID,
    status: state.settingsReducers.status,
    errMsg: state.settingsReducers.errMsg,
    selectSite: state.siteReducers.selectSite,
    menuMode: state.menuReducers.displayMode,
    modalPick: state.commonReducers.modalPick,
    loginStatus: state.loginReducers.status,
    accountOperationStatusList: state.settingsReducers.accountOperationStatusList,
    notifyItemData: state.menuReducers.data
  }
}

export default withRouter(connect(
  mapStateToProps,
  {
    openModal,
    openPickModal,
    popupModalConfirm,
    doConfirmAccountApply,
    doSelectAccount,
    doDeleteAccount,
    openModalAlert,
    doGetAccountDetail,
    loadAccountSettingList,
    saveAccountOperationStatus ,
    saveAccountOperationStatusInFrontEnd
  }
)(AccountSettingsList))
